// client/src/components/plataforma/siteInstitucional/SeoSettings.js
import React, { useCallback } from 'react';

const SeoSettings = React.memo(({ seo, onChange }) => {

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        const finalValue = name === 'keywords' ? value.split(',').map(k => k.trim()) : value;
        onChange({ ...seo, [name]: finalValue });
    }, [seo, onChange]);

    return (
        <div className="form-section mt-8">
            <h3 className="form-section-title">🔎 SEO (Otimização para Buscadores)</h3>
            <div className="form-grid-container grid-cols-1 md:grid-cols-2">
                <div className="form-group">
                    <label htmlFor="seo-title">Título do Site (para o Google)</label>
                    <input 
                        id="seo-title" 
                        type="text" 
                        name="title" 
                        value={seo.title || ''} 
                        onChange={handleChange} 
                        className="form-input" 
                        placeholder="Título do seu site" 
                    />
                </div>
                
                <div className="form-group">
                    <label htmlFor="seo-keywords">Palavras-chave (separadas por vírgula)</label>
                    <input 
                        id="seo-keywords" 
                        type="text" 
                        name="keywords" 
                        value={(seo.keywords || []).join(', ')} 
                        onChange={handleChange} 
                        className="form-input" 
                        placeholder="palavra1, palavra2, palavra3" 
                    />
                </div>
                
                <div className="form-group md:col-span-2">
                    <label htmlFor="seo-description">Descrição do Site (para o Google)</label>
                    <textarea 
                        id="seo-description" 
                        name="description" 
                        value={seo.description || ''} 
                        onChange={handleChange} 
                        className="form-input" 
                        rows="3" 
                        placeholder="Descrição do seu site para os mecanismos de busca" 
                    />
                </div>
            </div>
        </div>
    );
});

export default SeoSettings;